module.exports = __webpack_public_path__ + "static/img/certficate.c4d7480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certficate.png
// module id = VtTR
// module chunks = 1